import React, { useEffect, useState } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import {
  AdminCategory,
  getAdminCategories,
} from "../../api/adminCategoriesApi";

type Props = {
  label: string;
  helperText?: string;
  selectedIds: number[];
  onChange: (ids: number[]) => void;
};

export default function PromotionCategoryPicker({
  label,
  helperText,
  selectedIds,
  onChange,
}: Props) {
  const [categories, setCategories] = useState<AdminCategory[]>([]);

  useEffect(() => {
    getAdminCategories().then(setCategories).catch(() => setCategories([]));
  }, []);

  const selected = categories.filter((cat) => selectedIds.includes(cat.id));

  return (
    <Autocomplete
      multiple
      options={categories}
      value={selected}
      onChange={(_, value) => onChange(value.map((cat) => cat.id))}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.id}
            label={option.name}
            size="small"
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} helperText={helperText} />
      )}
    />
  );
}